import Vue from "vue";
import axios from "axios";
import config from "./config";

const utils = {
  formatTime: function(date, format) {
    if (typeof date === "string") {
      var mts = date.match(/(\/Date\((\d+)\)\/)/);
      if (mts && mts.length >= 3) {
        date = parseInt(mts[2]);
      }
    }
    date = new Date(date);
    if (!date || date.toUTCString() == "Invalid Date") {
      return "";
    }
    var map = {
      M: date.getMonth() + 1, //月份
      d: date.getDate(), //日
      h: date.getHours(), //小时
      m: date.getMinutes(), //分
      s: date.getSeconds(), //秒
      q: Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
      var v = map[t];
      if (v !== undefined) {
        if (all.length > 1) {
          v = "0" + v;
          v = v.substr(v.length - 2);
        }
        return v;
      } else if (t === "y") {
        return (date.getFullYear() + "").substr(4 - all.length);
      }
      return all;
    });
    return format;
  },
  getDzzxUrl(params, isPreview) {
    let url = `${config.dzzxHost}${isPreview ? "preview/" : ""}?t=${localStorage.getItem(
      "accessToken"
    )}&from=shopmanager`;
    Object.keys(params).forEach((key) => {
      url += `&${key}=${params[key]}`;
    });
    return url;
  },
  getStringLen(str) {
    var temp = 0;
    for (var i = 0; i < str.length; i++) {
      if (/[\u0391-\uFFE5]/.test(str[i])) {
        // /[u0391-uFFE5]/
        temp += 2;
      } else {
        temp++;
      }
    }
    return temp;
  },
  deepClone(params) {
    //深拷贝
    let obj = Array.isArray(params) ? [] : {};
    for (let attr in params) {
      if (typeof params[attr] == "object") {
        obj[attr] = params[attr] === null ? params[attr] : this.deepClone(params[attr]);
        continue;
      }
      obj[attr] = params[attr];
    }
    return obj;
  },
  timeFn(d1) {
    //di作为一个变量传进来
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateBegin = d1; //将-转化为/，使用new Date
    var dateEnd = new Date(); //获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000);
    return dateDiff;
    /*console.log(" 相差 "+dayDiff+"天 "+hours+"小时 "+minutes+" 分钟"+seconds+" 秒")
    console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数"
        ,hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");*/
  },
  //补零
  formatNumber(n) {
    n = n.toString();
    return n[1] ? n : "0" + n;
  },
  //时间戳格式化 formatTimestap(timestamp,'y-m-d h:m:s')
  formatTimestamp(timestamp, format) {
    let time = new Date(timestamp);
    let newArr = [];
    let formatArr = ["y", "M", "d", "h", "m", "s"];
    newArr.push(time.getFullYear());
    newArr.push(utils.formatNumber(time.getMonth() + 1));
    newArr.push(utils.formatNumber(time.getDate()));

    newArr.push(utils.formatNumber(time.getHours()));
    newArr.push(utils.formatNumber(time.getMinutes()));
    newArr.push(utils.formatNumber(time.getSeconds()));

    for (let i in newArr) {
      format = format.replace(formatArr[i], newArr[i]);
    }
    return format;
  },
  //获取域名链接等信息
  getDomain(url) {
    let host = "null";
    if (typeof url == "undefined" || null == url) url = window.location.href;
    let regex = /(\w+):\/\/([^/:]+)(:\d*)?/;
    let match = url.match(regex);
    if (typeof match != "undefined" && null != match) host = match[0];
    return host;
  },
  //埋点
  buryingpoint(data) {
    let userInfo = localStorage.getItem("userInfo");
    userInfo = userInfo ? JSON.parse(userInfo) : "";
    let opt = {
      userId: userInfo.kuaiOId ? userInfo.kuaiOId : "", //快哦id
      account: userInfo.userPhone ? userInfo.userPhone : "", //手机号
      functionTypeName: "",
      projectName: "快哦",
      success: "",
      fail: "",
      callback: "",
    };
    if (typeof data == "string") opt.functionTypeName = data;
    if (Object.prototype.toString.call(data) === "[object Object]") Object.assign(opt, data);
    let ajaxData = {
      userId: opt.userId + "", //快哦id
      account: opt.account + "", //手机号
      functionTypeName: opt.functionTypeName,
      projectName: "快哦",
    };
    axios.post("//api.fjdaze.com/buryingpoint/api/buryingpoint/save", ajaxData).then((res) => {
      if (res.data.code == 200) opt.success && opt.success(res);
      if (res.data.code != 200) opt.fail && opt.fail(res);
      opt.callback && opt.callback(res);
    });
  },
  /**
   * @name:setKuaioIdConfig
   * @Description: 设置用户的配置项
   * @param {String} valKey 需要存存储的配置值的KEY
   * @param {*} val 需要存存储的配置值 可为各种值
   * @return:
   * @Author: 陈文湘
   */

  setKuaioIdConfig(valKey, val) {
    let userInfo = localStorage.getItem("userInfo");
    if (!userInfo) {
      return;
    }
    let config = JSON.parse(localStorage.getItem("userInfo")).kuaiOId + "config";

    if (!localStorage.getItem(config)) {
      let str = {
        // seleCheckThes: [],  检测词库 选中的数组
      };
      str[valKey] = val;
      localStorage.setItem(config, JSON.stringify(str));
    } else {
      let data = JSON.parse(localStorage.getItem(config));
      data[valKey] = val;
      localStorage.setItem(config, JSON.stringify(data));
    }
  },
  /**
   * @name: getKuaioIdConfig
   * @Description: 获取用户配置项
   * @param {}
   * @return:
   * @Author: 陈文湘
   */

  getKuaioIdConfig() {
    let userInfo = localStorage.getItem("userInfo");
    if (!userInfo) {
      return {
        seleCheckThes: [],
      };
    }
    let config = JSON.parse(localStorage.getItem("userInfo")).kuaiOId + "config";
    return localStorage.getItem(config)
      ? JSON.parse(localStorage.getItem(config))
      : {
          seleCheckThes: [],
        };
  },
};

Vue.prototype.$utils = utils;
